export default __webpack_public_path__ + "static/media/egap-logo.ec1ef554.svg";